import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-job-reject-popup',
    standalone: true,
    imports: [CommonModule, MatIconModule, FormsModule],
    templateUrl: './job-reject-popup.component.html',
    styleUrl: './job-reject-popup.component.scss'
})
export class JobRejectPopupComponent {

    rejection_reason = '';
    showValidationError = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<JobRejectPopupComponent>,
    ) { }



    closeDialogBox() {
        this.dialogRef.close();
    }

    confirmApproval() {
        const reason = this.rejection_reason?.trim();

        if (!reason || reason.length < 5) {
            this.showValidationError = true;
            return;
        }

        this.showValidationError = false;
        this.dialogRef.close(this.rejection_reason);
    }

}
